import './TituloSessao.css';
import PropTypes from 'prop-types';

function TituloSessao({ titulo, barraDecorativa, tituloAlignStart = false, paddingEsquerdo = true }) {

    return (
        <div
            className={
                `titulo-sessao-container 
                d-flex
                ${paddingEsquerdo ? 'p-3' : 'p-3 ps-0'}
                ${tituloAlignStart ? 'justify-content-start' : 'justify-content-center'}`
            }
        >

            {barraDecorativa && (
                <span className="title-separator">" "</span>
            )}

            <h1 className="titulo-sessao m-0">
                {titulo}
            </h1>
        </div>
    );
}

TituloSessao.propTypes = {
    titulo: PropTypes.string.isRequired,
    barraDecorativa: PropTypes.bool.isRequired,
    tituloAlignStart: PropTypes.bool,
    paddingEsquerdo: PropTypes.bool
};

export default TituloSessao;
